@if (foreRojning) {
  <div>
    <rask-header size="4">Före röjning</rask-header>
    <div class="row mb-1">
      <div class="col">
        <rask-datepicker
          label="Mätdatum"
          [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
          [ngModel]="getMatDatum(foreRojning)"
          (ngModelChange)="matdatumChanged($event, foreRojning)">
        </rask-datepicker>
      </div>
    </div>
    <div class="row">
      @if (foreRojning) {
        <div class="col-10">
          <rask-skogsvard-tradskikt-tradslag
            (updated)="handleUpdates($event)"
            [skogsvardsAtgard]="skogsvardsAtgard"
            [allaTradslag]="allaTradslag"
            [kontraktReadonly]="kontraktReadonly"
            [rojningTradskikt]="foreRojning"
          ></rask-skogsvard-tradskikt-tradslag>
        </div>
      }
    </div>
  </div>
}

<div class="hr-div mt-4">
  <hr>
  </div>

  @if (efterRojning) {
    <div class="mt-2 mb-3">
      <rask-header size="4">Beräknat mål efter röjning</rask-header>
      <div class="row">
        @if (efterRojning) {
          <div class="col-10">
            <rask-skogsvard-tradskikt-tradslag
              (updated)="handleUpdates($event)"
              [skogsvardsAtgard]="skogsvardsAtgard"
              [allaTradslag]="allaTradslag"
              [kontraktReadonly]="kontraktReadonly"
              [rojningTradskikt]="efterRojning"
            ></rask-skogsvard-tradskikt-tradslag>
          </div>
        }
      </div>
    </div>
  }
